import { Navigate, useParams } from '@certificate/router';
import { useSearchParams } from 'react-router-dom';

export default function ExamEventExamineePage() {
  const { examEventExamineeId } = useParams('/exam-event-examinees/:examEventExamineeId');
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source');

  if (source === 'link') {
    return (
      <Navigate
        to='/exam-event-examinees/:examEventExamineeId/social-media'
        replace
        params={{ examEventExamineeId }}
      />
    );
  }

  return (
    <Navigate
      to='/exam-event-examinees/:examEventExamineeId/unofficial'
      replace
      params={{ examEventExamineeId }}
    />
  );
}
